<template>
  <div class="register">
    <h1 class="h1">请选择</h1>
    <div class="reg-type">
      <van-radio-group v-model="reg_type">
        <van-radio v-for="(g, index) in grade" :key="index" :name="g.id" class="type-m" v-show="g.show">
          <p class="p1">{{ g.name }}</p>
          <p class="p1 p2">注册享优惠</p>
        </van-radio>
      </van-radio-group>
    </div>
    <van-button type="default" class="reg-btn" @click="regType">确认</van-button>

    <Floating />
    <wxNoShare />
  </div>
</template>

<script>
import { Button, RadioGroup, Radio } from 'vant'

export default {
  components: {
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio
  },
  name: 'grade',
  data () {
    return {
      grade: [],
      reg_type: 0
    }
  },
  created() {
    this.$api.get('users/grade', null, r=>{
      r.data.map((item, index)=>{
        item.show = true
        if(item.id === this.$store.state.grade_id){
          item.show = false
        }
      })
      this.grade = r.data
    })
  },
  methods: {
    regType() {
      if(this.reg_type == 0){
        this.$toast('请选择注册类型')
      }else{
        this.$router.push('/upgrade/genre/'+this.reg_type)
      }
    }
  }
}
</script>
<style scoped>
  .register{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    position: fixed;
  }
  .register .h1{
    text-align: center;
    font-size: 23px;
    font-weight: normal;
    color:#3e3f3f;
    margin: 50px 0 30px;
  }
  .register .reg-type{
    margin: 0 10%;
    height: 200px;
    overflow: hidden;
  }
  .register .reg-type .p1{
    margin:0;
    padding:0;
    text-align: left;
    color:#3e3f3f;
    font-size: 16px;
  }
  .register .reg-type .p2{
    color:#969799;
    font-size: 14px;
    margin-top:5px;
  }
  .type-m{
    border:1px solid #ED6A0C;
    padding: 20px 15px;
    margin-bottom: 20px;
  }
  .reg-btn{
    background: #ED6B0D;
    color:#fff;
    width: 80%;
    border-radius: 25px;
    margin: 40px auto 0;
    display: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/views/upgrade/index.vue